<template>
	<div class>
		<div class="d-none d-lg-block d-xl-block">
			<div class="mt-5"></div>
		</div>
		<div class="row no-gutters" id="row-contenido">
			<!-- inicia sección side-bar -->
			<div class="col-2 d-none d-lg-flex side-bar collapse show bg-white pl-0">
				<div class="blue-bar"></div>
				<div class="posicion-menu-busqueda">
					
					<ul class="nav flex-column flex-nowrap overflow-hidden blue-bar-over">
						<li class="nav-item text-left my-3">
							<router-link
								@click.native="togleMenu(0)"
								class="text-truncate text-decoration-none"
								to="/clientes/"
							>
								<span class="d-none d-sm-inline welcome-text">Bienvenido</span>
								<div class="welcome-line"></div>
							</router-link>
						</li>
						<li class="nav-item text-left">
							<router-link
								:class="{ active: current == 0 }"
								@click.native="togleMenu(0)"
								class="nav-link text-truncate"
								to="/clientes/"
							>
								<i
									:class="[current == 0 ? 'text-white' : '','blue-bar-icon']"
									class="icon-grupo-4302 icon-bar"
								></i>
								<span class="nav-link-text d-none d-sm-inline">Inicio</span>
							</router-link>
						</li>
						<li class="nav-item text-left">
							<router-link
								:class="{ active: current == 8 }"
								:to="{name:'mi-lista-de-pedido'}"
								@click.native="togleMenu(8)"
								class="nav-link collapsed text-truncate"
							>
								<i
									:class="[current == 8 ? 'text-white' : '','blue-bar-icon']"
									class="icon-grupo-4303 icon-bar"
								></i>
								<span class="nav-link-text d-none d-sm-inline">Captura de pedidos</span>
								<!-- <img class="float-right" src="@/assets/img-priv/bficon.png" alt="" srcset=""> -->
							</router-link>
							<b-collapse class="mt-1 blue-bar-line" id="submenu">
								<!--<div class="collapse" id="submenu" aria-expanded="true">-->
								<ul class="nav flex-column pl-5">
									<li @click="submenu = 'listaPedido'" class="nav-item d-flex align-items-center">
										<!-- <div :class="{'blue-bar-point-icon':submenu == 'listaPedido'}"></div> -->
										<i
											:class="{'fa fa-caret-right menu-caret' : submenu == 'listaPedido', 'ml-2' : submenu != 'listaPedido'}"
										/>
										<router-link
											class="nav-link text-truncate"
											to="/clientes/captura-pedidos/mi-lista-de-pedido"
										>
											<span
												:class="{ 'nav-link-bold': submenu == 'listaPedido'}"
												class="nav-link-submenu-text d-none d-sm-inline"
											>Mi lista de pedido</span>
											<i class="icon-trazado-1106 star-icon"></i>
										</router-link>
									</li>
									<li class="nav-item text-left d-flex align-items-center" @click="submenu = 'catalogoGeneral'">
										<i
											:class="{'fa fa-caret-right menu-caret' : submenu == 'catalogoGeneral', 'ml-2' : submenu != 'catalogoGeneral'}"
										/>
										<router-link class="nav-link text-truncate" to="/clientes/captura-pedidos/busqueda-general?buscar=&orden=0&codClasificacion=0&codFormaFarmaceutica=0&tipoFormula=A&codFormula=0&contenidoVenta=0&pagina=1&busquedaAvanzada=false">
											<span
												:class="{'nav-link-bold': submenu == 'catalogoGeneral'}"
												class="nav-link-submenu-text d-none d-sm-inline"
											>Catálogo general</span>
										</router-link>
									</li>
									<li @click="submenu = 'nuevos'" class="nav-item text-left d-flex align-items-center">
										<i
											:class="{'fa fa-caret-right menu-caret' : submenu == 'nuevos', 'ml-2' : submenu != 'nuevos'}"
										/>
										<router-link to="/clientes/captura-pedidos/nuevos" class="nav-link text-truncate col">
											<span :class="{'nav-link-bold':submenu == 'nuevos'}"
													class="nav-link-submenu-text d-none d-sm-inline nav-link-text-nuevos"
											>Nuevos</span>
											<span class="badge badge-pill badge-yellow" v-if="totalNuevos > 0">{{totalNuevos}}</span>
										</router-link>
									</li>
									<li @click="submenu = 'ofertas'" class="nav-item text-left d-flex align-items-center">
										<i
											:class="{'fa fa-caret-right menu-caret' : submenu == 'ofertas', 'ml-2' : submenu != 'ofertas'}"
										/>
										<router-link class="nav-link text-truncate col" to="/clientes/captura-pedidos/ofertas">
											<span
												:class="{
													'nav-link-bold':
														submenu == 'ofertas'
												}"
												class="nav-link-submenu-text d-none d-sm-inline nav-link-text-ofertas"
											>Ofertas</span>
											<span class="badge badge-pill badge-green" v-if="totalOfertas > 0">{{totalOfertas}}</span>
										</router-link>
									</li>
									<li @click="submenu = 'remates'" class="nav-item text-left d-flex align-items-center">
										<i
											:class="{'fa fa-caret-right menu-caret' : submenu == 'remates', 'ml-2' : submenu != 'remates'}"
										/>
										<router-link class="nav-link text-truncate col" to="/clientes/captura-pedidos/remates">
											<span
												:class="{
													'nav-link-bold':
														submenu == 'remates'
												}"
												class="nav-link-submenu-text d-none d-sm-inline nav-link-text-remates"
											>Remates</span>
											<span class="badge badge-pill badge-red" v-if="totalRemates > 0">{{totalRemates}}</span>
										</router-link>
									</li>
									<li v-if="esBuenFin" @click="submenu = 'buenFin'" class="nav-item text-left d-flex align-items-center  buen-finbg">
										<i
											:class="{'fa fa-caret-right menu-caret' : submenu == 'buenFin', 'ml-2' : submenu != 'buenFin'}"
										/>
										<router-link class="nav-link text-truncate col" to="/clientes/captura-pedidos/buen-fin">
											<span
												:class="{
													'nav-link-bold':
														submenu == 'buenFin'
												}"
												class="nav-link-submenu-text d-none d-sm-inline nav-link-text-remates"
											>Buen Fin</span>
											<img class="ml-2" src="@/assets/img-priv/bficon.png" alt="" srcset="">
											<span class="badge badge-pill badge-red" v-if="totalBuenFin > 0">{{totalBuenFin}}</span>
										</router-link>
									</li>
									<li @click="submenu = 'cambiosPrecio'" class="nav-item text-left d-flex align-items-center">
										<i
											:class="{'fa fa-caret-right menu-caret' : submenu == 'cambiosPrecio', 'ml-2' : submenu != 'cambiosPrecio'}"
										/>
										<router-link
											class="nav-link text-truncate col"
											to="/clientes/captura-pedidos/cambio-de-precio"
										>
											<span
												:class="{
													'nav-link-bold':
														submenu == 'cambiosPrecio'
												}"
												class="nav-link-submenu-text d-none d-sm-inline"
											>Cambios de precios</span>
										</router-link>
									</li>
								</ul>
								<!--</div>-->
							</b-collapse>
						</li>
						<li class="nav-item text-left">
							<router-link
								:class="{ active: current == 1 }"
								@click.native="togleMenu(1)"
								class="nav-link text-truncate"
								to="/clientes/estatus-de-pedido"
							>
								<i
									:class="[
										current == 1 ? 'text-white' : '',
										'blue-bar-icon'
									]"
									class="icon-grupo-4304 icon-bar"
								></i>
								<span class="nav-link-text d-none d-sm-inline">Estatus de pedidos</span>
							</router-link>
						</li>
						<li class="nav-item text-left">
							<router-link
								:class="{ active: current == 2 }"
								@click.native="togleMenu(2)"
								class="nav-link text-truncate"
								to="/clientes/adeudos"
							>
								<i
									:class="[
										current == 2 ? 'text-white' : '',
										'blue-bar-icon'
									]"
									class="icon-grupo-4305 icon-bar"
								></i>
								<span class="nav-link-text d-none d-sm-inline">Adeudos</span>
							</router-link>
						</li>
						<li class="nav-item text-left">
							<router-link
								:class="{ active: current == 3 }"
								@click.native="togleMenu(3)"
								class="nav-link text-truncate"
								to="/clientes/facturas"
							>
								<i
									:class="[
										current == 3 ? 'text-white' : '',
										'blue-bar-icon'
									]"
									class="icon-grupo-4306 icon-bar"
								></i>
								<span class="nav-link-text d-none d-sm-inline">Facturas</span>
							</router-link>
						</li>
						<li class="nav-item text-left">
							<router-link
								:class="{ active: current == 4 }"
								@click.native="togleMenu(4)"
								class="nav-link text-truncate"
								to="/clientes/carrito"
							>
								<i
									:class="[
										current == 4 ? 'text-white' : '',
										'blue-bar-icon'
									]"
									class="icon-grupo-4307 icon-bar"
								></i>
								<span :class="{animacion : animarCarrito}" class="nav-link-text d-none d-sm-inline">Carrito</span>
								<span class="badge badge-pill badge-yellow">{{totalCarrito}}</span>
							</router-link>
						</li>
						<li class="nav-item text-left">
							<router-link
								:class="{ active: current == 5 }"
								@click.native="togleMenu(5)"
								class="nav-link text-truncate"
								to="/clientes/pagar"
							>
								<i
									:class="[
										current == 5 ? 'text-white' : '',
										'blue-bar-icon'
									]"
									class="icon-grupo-4308 icon-bar"
								></i>
								<span class="nav-link-text d-none d-sm-inline">Pago en Linea</span>
								<span class="circle-red"></span>
							</router-link>
						</li>
						<li class="nav-item text-left" v-if="permitirReferenciar">
							<router-link
								:class="{ active: current == 9 }"
								@click.native="togleMenu(9)"
								class="nav-link text-truncate"
								to="/clientes/referenciarpagos"
							>
								<i
									:class="[
										current == 9 ? 'text-white' : '',
										'blue-bar-icon'
									]"
									class="fa fa-file-invoice-dollar m-refpago"
								></i>
								<span class="nav-link-text d-none d-sm-inline">Referenciar pago</span>
								<!-- <span class="circle-red"></span> -->
							</router-link>
						</li>						
						<li class="nav-item text-left">
							<router-link
								:class="{ active: current == 6 }"
								@click.native="togleMenu(6)"
								class="nav-link text-truncate disabled"
								to="/clientes/estadisticas"
							>
								<i
									:class="[
										current == 6 ? 'text-white' : '',
										'blue-bar-icon'
									]"
									class="icon-grupo-4309 icon-bar"
								></i>
								<span class="nav-link-text d-none d-sm-inline opacity-50">
									Estadisticas
									<span class="font-10">¡próximamente!</span>
								</span>
							</router-link>
						</li>
						<li class="nav-item text-left">
							<router-link
								:class="{ active: current == 7 }"
								@click.native="togleMenu(7)"
								class="nav-link"
								to="/clientes/ayuda/0"
							>
								<i
									:class="[
										current == 7 ? 'text-white' : '',
										'blue-bar-icon'
									]"
									class="icon-grupo-4310 icon-bar"
								></i>
								<span class="nav-link-text d-none d-sm-inline">Ayuda</span>
							</router-link>
						</li>
						<li v-if="usuarioGlobal().user == 15893" class="nav-item text-left">
							<router-link
								:class="{ active: current == 8 }"
								@click.native="togleMenu(9)"
								class="nav-link"
								to="/clientes/herramientas"
							>
								<i
									:class="[
										current == 9 ? 'text-white' : '',
										'blue-bar-icon'
									]"
									class="fas fa-cogs"
								></i>"
								<span class="nav-link-text d-none d-sm-inline">Herramientas</span>
							</router-link>
						</li>
						<!-- <li class="nav-item text-left pt-3">
							<router-link
								:class="{ active: current == 5 }"
								@click.native="togleMenu(5)"
								class="nav-link text-truncate bg-warning"
								to="/clientes/pagar"
							>
								<i class="fas fa-undo pl-1 text-white" :class="[
										current == 5 ? 'text-white' : '',
										'blue-bar-icon'
									]"></i>
								<span class="nav-link-text d-none d-sm-inline text-white"> Versión anterior</span>
								
							</router-link>
						</li> -->
					</ul>
					<!-- <div>
						<pm-navegar-pagina-vieja ></pm-navegar-pagina-vieja>	
					</div> -->
					<div class="fixed-bottom private-legend ml-5">
						<span class="ml-2">
							Difarmer &reg; |
							<router-link to="/clientes/aviso-privacidad">Aviso de privacidad</router-link>
						</span>
					</div>
				</div>
			</div>
			<!-- fin sección side-bar -->

			<!-- Inicia sección contenido -->
			<div class="col-lg-10 col-12 px-2 pt-2 bg-gray text-left">
				<div class="row no-gutters">
					<div class="col-12 px-2">
						<slot name="contenido"></slot>
					</div>
				</div>
			</div>
			<!-- Fin sección contenido -->
		</div>
	</div>
</template>

<script>
// import PmNavegarPaginaVieja from '@/components/NavegarPaginaVieja'
	import { mapActions, mapState } from 'vuex'
	export default {
		name: "SideBar",
		props: [
			"msg",
			"totalCarrito",
			"totalNuevos",
			"totalOfertas",
			"totalRemates",
			"totalBuenFin",
			"animarCarrito",
			"busquedaGeneral",
			"inicioClientes",
			"sideBarTime",
			"sideBarValue",
			"opcion",
			"esBuenFin"
		],
		components:{
			// PmNavegarPaginaVieja
		},
		data() {
			
			return {
				current: 0,
				isColapsed: false,
				submenu: "listaPedido",
				// permitirReferenciar:false
			}
		},
		created(){
		},
		mounted() {
				this.$root.$on("bv::collapse::state", (collapseId, isJustShown) => {
				this.isColapsed = isJustShown
				// console.log("collapseId:", collapseId);
				// console.log("isJustShown:", isJustShown);
			})
			//console.log('tag', this.$root)
			this.ajustarContenedor()
			this.obeterAccesoReferenciar()
		},
		beforeMount() {
			window.addEventListener("resize", this.ajustarContenedor)
		},
		beforeDestroy() {
			window.removeEventListener("resize", this.ajustarContenedor)
		},
		computed:{
			...mapState(['busqueda','permitirReferenciar']),
		},
		methods: {
			...mapActions(['buscarProductos', 'resetParametros','obeterAccesoReferenciar']),			
			inicioCatalogoGeneral() {
				this.submenu = "catalogoGeneral"
				//this.buscar()

				this.$router.push({
					name: 'busqueda-general',
					query: this.busqueda.parametros
				})
			},
			togleMenu: function (opcion) {
				this.current = opcion
				
				if (this.current == 8 && !this.busquedaGeneral) {
					this.submenu = "listaPedido"
				}
				if (this.isColapsed && !this.busquedaGeneral) {
					this.$root.$emit("bv::toggle::collapse", "submenu")
				}
				if (!this.isColapsed && opcion == 8) {
					this.$root.$emit("bv::toggle::collapse", "submenu")
				}

				//this.busquedaGeneral = false
			},			
			ajustarContenedor() {
				//console.log('ajustarContenedor', '')
				if (this.$route.path.includes("mi-lista-de-pedido")) {
					
					this.togleMenu(8)
				} else if (this.$route.path.includes("busqueda-general")) {
					
					this.submenu = "catalogoGeneral"
					this.current = 8
					this.$nextTick(()=>{
						this.$root.$emit("bv::toggle::collapse", "submenu")
					})
					
				} 
				else if (this.$route.path.includes("nuevos")) {
					
					this.submenu = 'nuevos'
					this.current = 8
					this.$nextTick(()=>{
						this.$root.$emit("bv::toggle::collapse", "submenu")
					})
				} 
				else if (this.$route.path.includes("ofertas")) {
					this.submenu = 'ofertas'
					this.current = 8
					this.$nextTick(()=>{
						this.$root.$emit("bv::toggle::collapse", "submenu")
					})
				} else if (this.$route.path.includes("remates")) {
					this.submenu = 'remates'
					this.current = 8
					this.$nextTick(()=>{
						this.$root.$emit("bv::toggle::collapse", "submenu")
					})
				} else if (this.$route.path.includes("buenFin")) {
					this.submenu = 'buenFin'
					this.current = 8
					this.$nextTick(()=>{
							this.$root.$emit("bv::toggle::collapse", "submenu")
					})
				}else if (this.$route.path.includes("cambio-de-precio")) {
					this.submenu = 'cambiosPrecio'
					this.current = 8
					this.$nextTick(()=>{
						this.$root.$emit("bv::toggle::collapse", "submenu")
					})
				}else if (this.$route.path.includes("estatus-de-pedido")) {
					this.togleMenu(1)
				} else if (this.$route.path.includes("adeudos")) {
					this.togleMenu(2)
				} else if (this.$route.path.includes("facturas")) {
					this.togleMenu(3)
				} else if (this.$route.path.includes("carrito")) {
					this.togleMenu(4)
				} else if (this.$route.path.includes("pagar")) {
					this.togleMenu(5)
				} else if (this.$route.path.includes("ayuda")) {
					this.togleMenu(6)
				} else if (this.$route.path.includes("herramientas")) {
					this.togleMenu(9)
				}
				else if (this.$route.path.includes("referenciarpagos")) {
					this.togleMenu(9)
				}

				
				var headerHeight = document.getElementById("header").clientHeight
				var contenidoHeight = window.innerHeight
				document.getElementById("row-contenido").style.height =
					contenidoHeight - headerHeight + "px"
			},
		},
		watch: {
			busquedaGeneral(newValue) {
				if (newValue) {
					//console.log('busquedaGeneral(newValue)', newValue)
					this.submenu = "catalogoGeneral"
					this.togleMenu(8)
				}
			},
			inicioClientes(newValue) {
				if (newValue) {
					this.togleMenu(0)
				}
			},
			sideBarTime(newValue)
			{
				if(newValue)
				{
					this.current = this.sideBarValue
				}
			},
			opcion(newValue){
				if(newValue > 0){
					this.togleMenu(newValue)
				}
			}
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss" scoped>
	.m-refpago{
		margin-left: 9.5px;
		margin-right: 4.5px;
	}
	.posicion-menu-busqueda{
		position: fixed; 
		width: 100%;
	}

	.animacion {
		animation-name: carrito;
		animation-duration: 2s;
	}

	@keyframes carrito {
		0% {
			color: yellow;
		}
		50% {
			font-size: 1.3em;
		}
		100% {
			font-size: 1em;
			color: #000;
		}
	}

	.side-bar {
		/*min-width: 250px !important;*/
	}
	.bg-gray {
		background-color: #ebebeb;
	}

	.nav-link {
		padding: 0.4rem 0.5rem;
		margin-top: 0.1rem;
		color: var(--color-font-menu);
		font-size: 16px;
		font-weight: bold;
	}

	.nav-item .active {
		background: var(--bg-menu-blue);
		color: white !important;
		width: 16.7%;
		z-index: 0;
	}

	.nav-link-text {
		margin-left: 1.5rem;
		font-size: 16px;
		font-weight: bold;
	}

	.nav-link-submenu-text {
		font-size: 16px;
		/*margin-left: 1.3rem;*/
		padding-bottom: 1rem;
		color: #0a2157;
		font-weight: lighter;
	}

	.nav-link-text-nuevos {
		color: var(--bg-yellow);
	}

	.nav-link-text-ofertas {
		color: #4fc147;
	}

	.nav-link-text-remates {
		color: #ff0000;
	}

	.buen-finbg{
		background-color: rgb(255, 233, 233);
	}

	.nav-link-bold {
		font-weight: bold;
		/*margin-left: 1.65rem;*/
	}

	.badge-yellow {
		background-color: var(--bg-yellow);
		color: var(--bg-menu-blue);
		font-size: 12px;
		font-weight: lighter;
		margin-left: 0.5rem;
		font-weight: bold;
	}	

	.badge-green {
		background-color: #4fc147;
		color: white;
		font-size: 12px;
		font-weight: lighter;
		margin-left: 0.5rem;
	}

	.badge-red {
		background-color: #ff0000;
		color: white;
		font-size: 12px;
		font-weight: lighter;
		margin-left: 0.5rem;
	}

	.circle-red {
		display: inline-block;
		width: 0.6rem;
		height: 0.6rem;
		border-radius: 50%;
		background: red;
		justify-content: center;
		align-items: center;
		text-align: center;
		margin-left: 0.5rem;
	}

	.blue-bar {
		position: relative;
		background-color: var(--bg-menu-blue);
		width: 48px;
	}

	.blue-bar-over {
		position: absolute;
		/*background-color: blue;*/
		top: 0;
		left: 0;
		right: 0;
		/*margin: 0 auto;*/
		/*width: 100;*/
	}

	// .blue-bar-point-icon {
	// 	/*list-style: disc;*/
	// 	color: var(--bg-yellow);
	// 	margin-left: -12px;
	// 	font-size: 22px !important;
	// 	z-index: 1;
	// 	list-style-position: outside;
	// 	display: flex;
	// }

	// .blue-bar-point-icon::before {
	// 	font-family: "Font Awesome 5 Free"; font-weight: 900; content: "\f0da";
	// 	margin-left: -25px;
	// 	margin-top: 4px;
	// }

	.menu-caret {
		position: relative;
		left: -35px;
		font-size: 24px !important;
		color: var(--bg-yellow);
	}

	.blue-bar-icon {
		font-size: 23px;
	}

	.welcome-text {
		margin-left: 4rem;
		color: var(--bg-yellow);
		font-weight: bold;
		font-size: 20px;
	}

	.welcome-line {
		margin-left: 4rem;
		width: 10.7%;
		min-height: 0.2rem;
		background-color: var(--bg-yellow);
	}

	.blue-bar-line {
		margin: 0;
		padding: 0;
		position: relative;
		list-style: none;
	}

	.blue-bar-line::after {
		content: " ";
		pointer-events: none;
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		top: 0;
	}

	.blue-bar-line ul:before {
		content: "";
		height: 100%;
		opacity: 1;
		width: 0.07rem;
		background: #4868b2;
		position: absolute;
		left: 22px;
		top: 0;
		border-radius: 15px;
	}

	.blue-bar-icon {
		color: var(--color-font-icon);
	}

	.star-icon {
		color: var(--bg-yellow);
		font-size: 18px;
	}

	.private-legend {
		font-size: 11px;
		color: #101a33;
	}
</style>
